import React from "react";
export default function OnboardingSectionCard({
  icon,
  title,
  description,
  children,
}) {
  return (
    <div className="rounded-lg space-y-3.5">
      {(icon || title || description) && (
        <div
          className={`flex ${!description ? "items-center" : "items-start"} gap-2`}
        >
          {icon}
          {(title || description) && (
            <div>
              {title && (
                <h3 className="text-base font-semibold text-gray-800 dark:text-gray-100 font-['Inter']">
                  {title}
                </h3>
              )}
              {description && (
                <p className="text-sm font-normal mt-1 mb-2 text-gray-500 dark:text-gray-400">
                  {description}
                </p>
              )}
            </div>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
